/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown>, message: NonNullable<unknown> }} Snapshot_History_Commit_Option_LabelInputs */

const en_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commit by ${i?.user}: ${i?.message}`)
};

const fr_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commit par ${i?.user} : ${i?.message}`)
};

const de_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commit durch ${i?.user}: ${i?.message}`)
};

const it_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impegnati da ${i?.user}: ${i?.message}`)
};

const ru_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Подтвердить до ${i?.user}: ${i?.message}`)
};

const es_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Confirmado por ${i?.user}: ${i?.message}`)
};

const zh_cn2_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`提交者 ${i?.user}: ${i?.message}`)
};

const ja_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.user} によるコミット: ${i?.message}`)
};

const hi_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.user} द्वारा प्रतिबद्धता: ${i?.message}`)
};

const pt_pt2_snapshot_history_commit_option_label = /** @type {(inputs: Snapshot_History_Commit_Option_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Confirmação por ${i?.user}: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Commit by {user}: {message}" |
*
* @param {Snapshot_History_Commit_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_commit_option_label = /** @type {((inputs: Snapshot_History_Commit_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Commit_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snapshot_history_commit_option_label(inputs)
	if (locale === "de") return de_snapshot_history_commit_option_label(inputs)
	if (locale === "it") return it_snapshot_history_commit_option_label(inputs)
	if (locale === "ru") return ru_snapshot_history_commit_option_label(inputs)
	if (locale === "es") return es_snapshot_history_commit_option_label(inputs)
	if (locale === "zh-CN") return zh_cn2_snapshot_history_commit_option_label(inputs)
	if (locale === "ja") return ja_snapshot_history_commit_option_label(inputs)
	if (locale === "hi") return hi_snapshot_history_commit_option_label(inputs)
	if (locale === "pt-PT") return pt_pt2_snapshot_history_commit_option_label(inputs)
	return en_snapshot_history_commit_option_label(inputs)
});